export const cityNamesMap = {
  'ירושלים': 'Jerusalem',
  'תל אביב': 'Tel Aviv',
  'חיפה': 'Haifa',
  'באר שבע': 'Beersheba',
  'אדמית': 'Adamit',
  'עדנים': 'Adanim',
  'אדרת': 'Aderet',
  'אדירים': 'Adirim',
  'עדי': 'Adi',
  'אדורה': 'Adora',
  'אפק': 'Afek',
  'אפיק': 'Afik',
  'אפיקים': 'Afikim',
  'עפולה': 'Afula',
  'עגור': 'Agur',
  'אחווה': 'Ahva',
  'אחיעזר': 'Ahiezer',
  'אחיהוד': 'Ahihud',
  'אחיסמך': 'Ahisamakh',
  'אחיטוב': 'Ahituv',
  'אחוזם': 'Ahuzam',
  'אחוזת ברק': 'Ahuzat Barak',
  'עכו': 'Akko',
  'עלי זהב': 'Ale Zahav',
  'אלפי מנשה': 'Alfei Menashe',
  'אלון הגליל': 'Alon HaGalil',
  'אלון שבות': 'Alon Shvut',
  'אלוני אבא': 'Alonei Abba',
  'אלוני הבשן': 'Alonei HaBashan',
  'אלוני יצחק': 'Alonei Yitzhak',
  'אלונים': 'Alonim',
  'עלמה': 'Alma',
  'אלמגור': 'Almagor',
  'אלמוג': 'Almog',
  'עלמון': 'Almon',
  'עלומים': 'Alumim',
  'אלומה': 'Alumah',
  'אלומות': 'Alumot',
  'אמציה': 'Amatzia',
  'עמיר': 'Amir',
  'אמירים': 'Amirim',
  'עמיעד': 'Amiad',
  'עמיעוז': 'Amioz',
  'עמיחי': 'Amichai',
  'עמינדב': 'Aminadav',
  'עמיקם': 'Amikam',
  'אמנון': 'Amnun',
  'עמקה': 'Amka',
  'עמוקה': 'Amuka',
  'אניעם': 'Aniam',
  'ערד': 'Arad',
  'ארבל': 'Arbel',
  'ארגמן': 'Argaman',
  'אריאל': 'Ariel',
  'ערוגות': 'Arugot',
  'אספר': 'Asper',
  'עשרת': 'Aseret',
  'אשלים': 'Ashalim',
  'אשדוד': 'Ashdod',
  'אשרת': 'Asherat',
  'אשקלון': 'Ashkelon',
  'עטרת': 'Ateret',
  'עתלית': 'Atlit',
  'עצמון שגב': 'Atsmon Segev',
  'עבדון': 'Avdon',
  'אבנת': 'Avnat',
  'אביאל': 'Aviel',
  'אביעזר': 'Aviezer',
  'אביגדור': 'Avigdor',
  'אביחיל': 'Avihail',
  'אביטל': 'Avital',
  'אביבים': 'Avivim',
  'אבני איתן': 'Avnei Eitan',
  'אבני חפץ': 'Avnei Hefetz',
  'אבשלום': 'Avshalom',
  'אבטליון': 'Avtalyon',
  'עיינות': 'Ayanot',
  'איילת השחר': 'Ayelet HaShahar',
  'עזריה': 'Azaria',
  'אזור': 'Azor',
  'עזריאל': 'Azriel',
  'עזריקם': 'Azrikam',
  'בחן': 'Bahan',
  'בלפוריה': 'Balfouriya',
  'בר גיורא': 'Bar Giora',
  'בר יוחאי': 'Bar Yochai',
  'ברעם': 'Baram',
  'ברק': 'Barak',
  'ברקת': 'Bareket',
  'ברקן': 'Barkan',
  'ברקאי': 'Barkai',
  'בסמה': 'Basma',
  'בסמת טבעון': 'Basmat Tivon',
  'בת עין': 'Bat Ayin',
  'בת הדר': 'Bat Hadar',
  'בת חפר': 'Bat Hefer',
  'בת חן': 'Bat Hen',
  'בת שלמה': 'Bat Shlomo',
  'בת ים': 'Bat Yam',
  'בצרה': 'Batzra',
  'באר מילכה': 'Beer Milka',
  'באר אורה': 'Beer Ora',
  'באר טוביה': 'Beer Tuvia',
  'באר יעקב': 'Beer Yaakov',
  'בארי': 'Beeri',
  'בארות יצחק': 'Beerot Yitzhak',
  'בארותיים': 'Beerotayim',
  'באר גנים': 'Beer Gannim',
  'בית גן': 'Beit Gan',
  'בן עמי': 'Ben Ami',
  'בן שמן': 'Ben Shemen',
  'בן זכאי': 'Ben Zakkai',
  'בניה': 'Benaya',
  'בני עטרות': 'Bnei Atarot',
  'בני עיש': 'Bnei Ayish',
  'בני ברק': 'Bnei Brak',
  'בני דרום': 'Bnei Darom',
  'בני דרור': 'Bnei Dror',
  'בני נצרים': 'Bnei Netzarim',
  'בני ראם': 'Bnei Ram',
  'בני יהודה': 'Bnei Yehuda',
  'בני ציון': 'Bnei Zion',
  'בקעות': 'Bekaot',
  'בקוע': 'Bekoa',
  'ברכה': 'Bracha',
  'ברכיה': 'Brakhiya',
  'ברור חיל': 'Brur Hayil',
  'ברוש': 'Brosh',
  'בית אלפא': 'Beit Alfa',
  'בית עריף': 'Beit Arif',
  'בית אריה': 'Beit Aryeh',
  'בית ברל': 'Beit Berl',
  'בית דגן': 'Beit Dagan',
  'בית אל': 'Beit El',
  'בית אלעזרי': 'Beit Elazari',
  'בית עזרא': 'Beit Ezra',
  'בית גמליאל': 'Beit Gamliel',
  'בית גוברין': 'Beit Guvrin',
  'בית הערבה': 'Beit HaArava',
  'בית העמק': 'Beit HaEmek',
  'בית הגדי': 'Beit HaGadi',
  'בית הלוי': 'Beit HaLevi',
  'בית חנן': 'Beit Hanan',
  'בית חנניה': 'Beit Hananya',
  'בית השיטה': 'Beit HaShita',
  'בית חשמונאי': 'Beit Hashmonai',
  'בית חירות': 'Beit Herut',
  'בית הלל': 'Beit Hillel',
  'בית חלקיה': 'Beit Hilkiya',
  'בית חורון': 'Beit Horon',
  'בית לחם הגלילית': 'Beit Lehem HaGlilit',
  'בית מאיר': 'Beit Meir',
  'בית נחמיה': 'Beit Nehemia',
  'בית נקופה': 'Beit Nekufa',
  'בית ניר': 'Beit Nir',
  'בית אורן': 'Beit Oren',
  'בית עובד': 'Beit Oved',
  'בית קמה': 'Beit Kama',
  'בית קשת': 'Beit Keshet',
  'בית רבן': 'Beit Raban',
  'בית רימון': 'Beit Rimon',
  'בית שאן': 'Beit Shean',
  'בית שערים': 'Beit Shearim',
  'בית שמש': 'Beit Shemesh',
  'בית שקמה': 'Beit Shikma',
  'בית עוזיאל': 'Beit Uziel',
  'בית ינאי': 'Beit Yanai',
  'בית יהושע': 'Beit Yehoshua',
  'בית יצחק': 'Beit Yitzhak',
  'בית יוסף': 'Beit Yosef',
  'בית זית': 'Beit Zayit',
  'בית זיד': 'Beit Zeid',
  'בית זרע': 'Beit Zera',
  'בית צבי': 'Beit Zvi',
  'ביתר עילית': 'Beitar Illit',
  'בצת': 'Betzet',
  'בענה': 'Bina',
  'בנימינה-גבעת עדה': 'Binyamina-Givat Ada',
  'ביר הדאג': 'Bir Hadaj',
  'ביריה': 'Biriya',
  'ביתן אהרן': 'Bitan Aharon',
  'בטחה': 'Bitcha',
  'ביצרון': 'Bitzaron',
  'בני דקלים': 'Bnei Dekalim',
  'ברוכין': 'Bruchin',
  'בועיינה-נוגידאת': 'Bueine Nujeidat',
  'בוקעאתא': 'Buqata',
  'בורגתה': 'Burgata',
  'בוסתן הגליל': 'Bustan HaGalil',
  'דבוריה': 'Daburiya',
  'דפנה': 'Dafna',
  'דחי': 'Dahi',
  'דאלית אל-כרמל': 'Daliyat al-Karmel',
  'דליה': 'Daliya',
  'דלתון': 'Dalton',
  'דן': 'Dan',
  'דברת': 'Davrat',
  'דגניה א': 'Degania Alef',
  'דגניה ב': 'Degania Bet',
  'דייר חנא': 'Deir Hanna',
  'דייר ראפאת': 'Deir Rafat',
  'דמיידה': 'Demeide',
  'דקל': 'Dekel',
  'דבורה': 'Devora',
  'דימונה': 'Dimona',
  'דישון': 'Dishon',
  'דולב': 'Dolev',
  'דור': 'Dor',
  'דורות': 'Dorot',
  'דובב': 'Dovev',
  'דביר': 'Dvir',
  'אפרת': 'Efrat',
  'עיילבון': 'Eilabun',
  'עין אל-אסד': 'Ein al-Asad',
  'עין חוד': 'Ein Hod',
  'עין מאהל': 'Ein Mahil',
  'עין נקובא': 'Ein Naqquba',
  'עין קנייא': 'Ein Qiniyye',
  'עין ראפה': 'Ein Rafa',
  'אלעד': 'Elad',
  'אלעזר': 'Elazar',
  'אל-רום': 'El-Rom',
  'אילת': 'Eilat',
  'עלי': 'Eli',
  'אלי-עד': 'Eli Ad',
  'אליאב': 'Eliav',
  'אליפז': 'Elifaz',
  'אליפלט': 'Elifelet',
  'אלישמע': 'Elishama',
  'אילון': 'Elon',
  'אלון מורה': 'Elon Moreh',
  'אילות': 'Elot',
  'אלקנה': 'Elkana',
  'אלקוש': 'Elkosh',
  'אליכין': 'Elyachin',
  'אליקים': 'Elyakim',
  'אלישיב': 'Elyashiv',
  'אמונים': 'Emunim',
  'עין איילה': 'En Ayala',
  'עין דור': 'En Dor',
  'עין גדי': 'En Gedi',
  'עין גב': 'En Gev',
  'עין הבשור': 'En HaBesor',
  'עין העמק': 'En HaEmek',
  'עין החורש': 'En HaHoresh',
  'עין המפרץ': 'En HaMifratz',
  'עין הנציב': 'En HaNatziv',
  'עין חרוד': 'En Harod',
  'עין השלושה': 'En HaShlosha',
  'עין השופט': 'En HaShofet',
  'עין חצבה': 'En Hazeva',
  'עין הוד': 'En Hod',
  'עין עירון': 'En Iron',
  'עין כרם': 'En Karem',
  'עין כרמל': 'En Karmel',
  'עין שריד': 'En Sarid',
  'עין שמר': 'En Shemer',
  'עין תמר': 'En Tamar',
  'עין ורד': 'En Vered',
  'עין יעקב': 'En Yaakov',
  'עין יהב': 'En Yahav',
  'עין זיוון': 'En Zivan',
  'עין צורים': 'En Tzurim',
  'עינת': 'Enat',
  'ענב': 'Enav',
  'ארז': 'Erez',
  'אשבול': 'Eshbol',
  'אשל הנשיא': 'Eshel HaNasi',
  'אשחר': 'Eshhar',
  'אשכולות': 'Eshkolot',
  'אשתאול': 'Eshtaol',
  'איתן': 'Eitan',
  'איתנים': 'Etanim',
  'אתגר': 'Etgar',
  'אבן מנחם': 'Even Menahem',
  'אבן ספיר': 'Even Sapir',
  'אבן שמואל': 'Even Shmuel',
  'אבן יהודה': 'Even Yehuda',
  'גלעד': 'Gilad',
  'עברון': 'Evron',
  'אייל': 'Eyal',
  'עזר': 'Ezer',
  'עזוז': 'Ezuz',
  'פסוטה': 'Fassuta',
  'פוריידיס': 'Fureidis',
  'געש': 'Gaash',
  'געתון': 'Gaton',
  'גדיש': 'Gadish',
  'גדות': 'Gadot',
  'גלאון': 'Galon',
  'גן הדרום': 'Gan HaDarom',
  'גן השומרון': 'Gan HaShomron',
  'גן חיים': 'Gan Haim',
  'גן נר': 'Gan Ner',
  'גן שלמה': 'Gan Shlomo',
  'גן שמואל': 'Gan Shmuel',
  'גן שורק': 'Gan Sorek',
  'גן יבנה': 'Gan Yavne',
  'גן יאשיה': 'Gan Yoshiya',
  'גני עם': 'Ganei Am',
  'גני הדר': 'Ganei Hadar',
  'גני מודיעין': 'Ganei Modiin',
  'גני טל': 'Ganei Tal',
  'גני תקווה': 'Ganei Tikva',
  'גני יוחנן': 'Ganei Yohanan',
  'גנות': 'Ganot',
  'גנות הדר': 'Ganot Hadar',
  'גת רימון': 'Gat Rimon',
  'גת': 'Gat',
  'גזית': 'Gazit',
  'גיאה': 'Geya',
  'גאליה': 'Gealia',
  'גאולי תימן': 'Geulei Teiman',
  'גאולים': 'Geulim',
  'גדרה': 'Gedera',
  'גפן': 'Gefen',
  'גליל ים': 'Galil Yam',
  'גרופית': 'Grofit',
  'גשר': 'Gesher',
  'גשר הזיו': 'Gesher HaZiv',
  'גשור': 'Geshur',
  'גבע': 'Geva',
  'גבע כרמל': 'Geva Carmel',
  'גבע בנימין': 'Geva Binyamin',
  'גבעות בר': 'Gvaot Bar',
  'גברעם': 'Gvaram',
  'גבת': 'Gvat',
  'גבים': 'Gevim',
  'גבולות': 'Gevulot',
  'גבעתיים': 'Givatayim',
  'גבעתי': 'Givati',
  'גבעולים': 'Givolim',
  'גבעון החדשה': 'Givon HaHadasha',
  'גיזו': 'Gizo',
  'גונן': 'Gonen',
  'גורן': 'Goren',
  'גורנות הגליל': 'Gornot HaGalil',
  'הבונים': 'HaBonim',
  'חד-נס': 'Had-Nes',
  'הדר עם': 'Hadar Am',
  'חדרה': 'Hadera',
  'חדיד': 'Hadid',
  'חפץ חיים': 'Hafetz Haim',
  'חגי': 'Haggai',
  'חגור': 'Hagor',
  'הגושרים': 'HaGoshrim',
  'החותרים': 'HaHotrim',
  'חלוץ': 'Halutza',
  'המעפיל': 'HaMaapil',
  'חמדיה': 'Hamadya',
  'חמאם': 'Hammam',
  'חמרה': 'Hamra',
  'חניתה': 'Hanita',
  'חנתון': 'Haniton',
  'חניאל': 'Haniel',
  'העוגן': 'HaOgen',
  'האון': 'HaOn',
  'הר אדר': 'Har Adar',
  'הר עמשא': 'Har Amassa',
  'הר גילה': 'Har Gilo',
  'הראל': 'Harel',
  'הררית': 'Hararit',
  'חרשים': 'Harashim',
  'הרדוף': 'Harduf',
  'חריש': 'Harish',
  'חרוצים': 'Harutzim',
  'חשמונאים': 'Hashmonaim',
  'הסוללים': 'HaSolelim',
  'חספין': 'Hispin',
  'חבצלת השרון': 'Havatzelet HaSharon',
  'הוואשלה (שבט)': 'Hawashleh (Shevet)',
  'היוגב': 'HaYogev',
  'חצב': 'Hatzav',
  'חצרים': 'Hatzerim',
  'חצבה': 'Hatzeva',
  'חזון': 'Hazon',
  'חצור הגלילית': 'Hatzor HaGalilit',
  'חצור-אשדוד': 'Hatzor-Ashdod',
  'הזורעים': 'HaZoreim',
  'הזורע': 'HaZorea',
  'חפצי-בה': 'Hefzi-Bah',
  'חלץ': 'Helez',
  'חמד': 'Hemda',
  'חרמש': 'Hermesh',
  'חירות': 'Herut',
  'הרצליה': 'Herzliya',
  'חבר': 'Hever',
  'חיבת ציון': 'Hibat Tzion',
  'הילה': 'Hila',
  'חיננית': 'Hinanit',
  'הוד השרון': 'Hod HaSharon',
  'הודיות': 'Hodiyot',
  'הודיה': 'Hodiya',
  'חופית': 'Hofit',
  'חגלה': 'Hogla',
  'חולית': 'Holit',
  'חולון': 'Holon',
  'חורשים': 'Horshim',
  'חוסן': 'Hosen',
  'הושעיה': 'Hoshaya',
  'חוגייראת (דהרה)': 'Hujeirat (Dehara)',
  'חולתה': 'Hulata',
  'חולדה': 'Hulda',
  'חוקוק': 'Huqoq',
  'חורה': 'Hura',
  'חורפיש': 'Hurfeish',
  'חוסנייה': 'Hussniyya',
  'הוזייל (שבט)': 'Huzeil (Shevet)',
  'עידן': 'Idan',
  'אילניה': 'Ilaniya',
  'עילוט': 'Ilut',
  'עמנואל': 'Immanuel',
  'עיר אובות': 'Ir Ovot',
  'אירוס': 'Irus',
  'איתמר': 'Itamar',
  'גלגוליה': 'Jaljulya',
  'גש (גוש חלב)': 'Jish (Gush Halav)',
  'גסר א-זרקא': 'Jisr az-Zarqa',
  'גדיידה': 'Judeida',
  'כעביה-טבאש-חגאגרה': 'Kaabiya-Tabbash-Hajajre',
  'כברי': 'Kabri',
  'כאבול': 'Kabul',
  'כדיתה': 'Kadita',
  'כדורי': 'Kadoorie',
  'כפר ברא': 'Kafr Bara',
  'כפר כמא': 'Kafr Kama',
  'כפר כנא': 'Kafr Kanna',
  'כפר מנדא': 'Kafr Manda',
  'כפר מצר': 'Kafr Misr',
  'כפר קרע': 'Kafr Qara',
  'כפר קאסם': 'Kafr Qassem',
  'כפר יאסיף': 'Kafr Yasif',
  'כחל': 'Kahal',
  'כלנית': 'Kalanit',
  'כמון': 'Kamon',
  'כנף': 'Kanaf',
  'כנות': 'Kannot',
  'כאוכב אבו אל-היגא': 'Kaokab Abu al-Hija',
  'כרי דשא': 'Karei Deshe',
  'כרכום': 'Karkom',
  'כרמי קטיף': 'Karmei Katif',
  'כרמי יוסף': 'Karmei Yosef',
  'כרמי צור': 'Karmei Tzur',
  'כרמל': 'Karmel',
  'כרמיאל': 'Karmiel',
  'כרמיה': 'Karmiyya',
  'כפר אדומים': 'Kfar Adumim',
  'כפר אחים': 'Kfar Ahim',
  'כפר אביב': 'Kfar Aviv',
  'כפר עבודה': 'Kfar Avoda',
  'כפר עזה': 'Kfar Aza',
  'כפר ברוך': 'Kfar Baruch',
  'כפר ביאליק': 'Kfar Bialik',
  'כפר בילו': 'Kfar Bilu',
  'כפר בן נון': 'Kfar Ben Nun',
  'כפר בלום': 'Kfar Blum',
  'כפר דניאל': 'Kfar Daniel',
  'כפר עציון': 'Kfar Etzion',
  'כפר גלים': 'Kfar Galim',
  'כפר גדעון': 'Kfar Gideon',
  'כפר גלעדי': 'Kfar Giladi',
  'כפר גליקסון': 'Kfar Glikson',
  'כפר חבד': 'Kfar Habad',
  'כפר החורש': 'Kfar HaHoresh',
  'כפר המכבי': 'Kfar HaMaccabi',
  'כפר הנגיד': 'Kfar HaNagid',
  'כפר חנניה': 'Kfar Hananya',
  'כפר הנשיא': 'Kfar HaNasi',
  'כפר הנוער הדתי': 'Kfar HaNoar HaDati',
  'כפר האורנים': 'Kfar HaOranim',
  'כפר הריף': 'Kfar HaRif',
  'כפר חרוב': 'Kfar Haruv',
  'כפר חסידים א': 'Kfar Hasidim Alef',
  'כפר חסידים ב': 'Kfar Hasidim Bet',
  'כפר חיים': 'Kfar Hayim',
  'כפר הס': 'Kfar Hess',
  'כפר חיטים': 'Kfar Hittim',
  'כפר חושן': 'Kfar Hoshen',
  'כפר קיש': 'Kfar Kish',
  'כפר מלל': 'Kfar Malal',
  'כפר מסריק': 'Kfar Masaryk',
  'כפר מימון': 'Kfar Maimon',
  'כפר מנחם': 'Kfar Menahem',
  'כפר מונש': 'Kfar Monash',
  'כפר מרדכי': 'Kfar Mordechai',
  'כפר נטר': 'Kfar Netter',
  'כפר פינס': 'Kfar Pines',
  'כפר ראש הנקרה': 'Kfar Rosh HaNikra',
  'כפר רוזנואלד (זרעית)': 'Kfar Rosenwald (Zarit)',
  'כפר רופין': 'Kfar Ruppin',
  'כפר רות': 'Kfar Rut',
  'כפר סבא': 'Kfar Saba',
  'כפר שמאי': 'Kfar Shamai',
  'כפר שמריהו': 'Kfar Shmaryahu',
  'כפר שמואל': 'Kfar Shmuel',
  'כפר סילבר': 'Kfar Silver',
  'כפר סירקין': 'Kfar Sirkin',
  'כפר סאלד': 'Kfar Sold',
  'כפר תפוח': 'Kfar Tapuach',
  'כפר תבור': 'Kfar Tavor',
  'כפר טרומן': 'Kfar Truman',
  'כפר אוריה': 'Kfar Uriya',
  'כפר ויתקין': 'Kfar Vitkin',
  'כפר ורבורג': 'Kfar Warburg',
  'כפר ורדים': 'Kfar Vradim',
  'כפר יעבץ': 'Kfar Yabetz',
  'כפר יחזקאל': 'Kfar Yehezkel',
  'כפר יהושע': 'Kfar Yehoshua',
  'כפר יונה': 'Kfar Yona',
  'כפר זיתים': 'Kfar Zeitim',
  'כפר זוהרים': 'Kfar Zoarim',
  'כליל': 'Klil',
  'כמהין': 'Kmehin',
  'כרמים': 'Kramim',
  'כרם בן שמן': 'Karm Ben Shemen',
  'כרם בן זמרה': 'Kerm Ben Zimra',
  'כרם מהרל': 'Kerem Maharal',
  'כרם שלום': 'Kerem Shalom',
  'כסלון': 'Kesalon',
  'חואלד (שבט)': 'Khawaled (Shevet)',
  'חואלד': 'Khawaled',
  'כנרת (מושבה)': 'Kinneret (Moshava)',
  'כנרת (קבוצה)': 'Kinneret (Kvutza)',
  'כישור': 'Kishor',
  'כסרא-סמיע': 'Kisra-Sumei',
  'כיסופים': 'Kissufim',
  'כחלה': 'Kohila',
  'כוכב השחר': 'Kokhav HaShahar',
  'כוכב מיכאל': 'Kokhav Mikhael',
  'כוכב יעקב': 'Kokhav Yaakov',
  'כוכב יאיר': 'Kokhav Yair',
  'כורזים': 'Korazim',
  'כסיפה': 'Kuseife',
  'להב': 'Lahav',
  'להבות הבשן': 'Lahavot HaBashan',
  'להבות חביבה': 'Lahavot Haviva',
  'לכיש': 'Lakhish',
  'לפיד': 'Lapid',
  'לפידות': 'Lapidot',
  'לקיה': 'Lakiya',
  'לביא': 'Lavi',
  'לבון': 'Lavon',
  'להבים': 'Lehavim',
  'שריגים (לי-און)': 'Li-On (Srigim)',
  'לימן': 'Limann',
  'לבנים': 'Livnim',
  'לוד': 'Lod',
  'לוחמי הגיטאות': 'Lochamei HaGetaot',
  'לוטן': 'Lotan',
  'לוטם': 'Lotem',
  'לוזית': 'Luzit',
  'מעגן': 'Maagan',
  'מעגן מיכאל': 'Maagan Michael',
  'מעלה אדומים': 'Maale Adumim',
  'מעלה עמוס': 'Maale Amos',
  'מעלה אפרים': 'Maale Efraim',
  'מעלה גמלא': 'Maale Gamla',
  'מעלה גלבוע': 'Maale Gilboa',
  'מעלה החמישה': 'Maale HaHamisha',
  'מעלה עירון': 'Maale Iron',
  'מעלה לבונה': 'Maale Levona',
  'מעלה מכמש': 'Maale Mikhmas',
  'מעלות-תרשיחא': 'Ma’alot-Tarshiha',
  'מענית': 'Ma’anit',
  'מעש': 'Maas',
  'מעברות': 'Maabarot',
  'מעגלים': 'Maagalim',
  'מעון': 'Maon',
  'מאור': 'Maor',
  'מעין ברוך': 'Maayan Barukh',
  'מעין צבי': 'Maayan Tzvi',
  'מבועים': 'Mabuim',
  'מגן': 'Magen',
  'מגן שאול': 'Magen Shaul',
  'מגל': 'Maggul',
  'מגשימים': 'Magshimim',
  'מחניים': 'Mahaniyim',
  'צוקים': 'Mitzpe Tsukim',
  'מחנה הילה': 'Machaneh Hila',
  'מחנה מרים': 'Machaneh Miriam',
  'מחנה טלי': 'Machaneh Tali',
  'מחנה תל נוף': 'Machaneh Tel Nof',
  'מחנה יפה': 'Machaneh Yaffa',
  'מחנה יתיר': 'Machaneh Yatir',
  'מחנה יהודית': 'Machaneh Yehudit',
  'מחנה יוכבד': 'Machaneh Yocheved',
  'מחסיה': 'Makhseya',
  'מגד אל-כרום': 'Majd al-Krum',
  'מגדל שמס': 'Majdal Shams',
  'מכחול': 'Makhul',
  'מלכיה': 'Malchia',
  'מנוף': 'Manof',
  'מנות': 'Manot',
  'מנשית זבדה': 'Manshiyat Zabda',
  'מרגליות': 'Margaliyot',
  'מסעדה': 'Masadeh',
  'מסעודין אל-עזאזמה': 'Masudin al-Azazma',
  'משאבי שדה': 'Mashabei Sade',
  'מסד': 'Masad',
  'מסדה': 'Masada',
  'משואה': 'Masaot',
  'משואות יצחק': 'Masaot Yitzhak',
  'מטע': 'Mata',
  'מתן': 'Matan',
  'מתת': 'Matat',
  'מתתיהו': 'Mattityahu',
  'מבקיעים': 'Mavqiim',
  'מזכרת בתיה': 'Mazkeret Batya',
  'מצליח': 'Matzliach',
  'מזור': 'Mezor',
  'מצובה': 'Metzuba',
  'מי עמי': 'Mei Ami',
  'מאיר שפיה': 'Meir Shfeya',
  'מעונה': 'Meona',
  'מפלסים': 'Mefalsim',
  'מגדים': 'Megadim',
  'מגידו': 'Megiddo',
  'מחולה': 'Mehola',
  'מייסר': 'Meisar',
  'מכורה': 'Mehora',
  'מלאה': 'Mela',
  'מלילות': 'Melilot',
  'מנחמיה': 'Menahemya',
  'מנרה': 'Menara',
  'מנוחה': 'Menuha',
  'מירב': 'Merav',
  'מרחב עם': 'Merhav Am',
  'מרחביה (מושב)': 'Merhavya (Moshav)',
  'מרחביה (קיבוץ)': 'Merhavya (Kibbutz)',
  'מרכז שפירא': 'Merkaz Shapira',
  'מרום גולן': 'Merom Golan',
  'מירון': 'Meron',
  'מישר': 'Mesheq',
  'משהד': 'Meshed',
  'מסילת ציון': 'Mesilat Zion',
  'מסילות': 'Mesilot',
  'מיטל': 'Metel',
  'מיתר': 'Metar',
  'מיטב': 'Meitav',
  'מטולה': 'Metula',
  'מבשרת ציון': 'Mevaseret Zion',
  'מבוא ביתר': 'Mevo Beitar',
  'מבוא דותן': 'Mevo Dotan',
  'מבוא חמה': 'Mevo Hama',
  'מבוא חורון': 'Mevo Horon',
  'מבוא מודיעים': 'Mevo Modiim',
  'מבואות ים': 'Mevoot Yam',
  'מבואות יריחו': 'Mevoot Yeriho',
  'מצדות יהודה': 'Metzadot Yehuda',
  'מיצר': 'Mitzar',
  'מצר': 'Metzer',
  'מעיליא': 'Meilia',
  'מדרך עוז': 'Midrach Oz',
  'מדרשת בן גוריון': 'Midreshet Ben Gurion',
  'מדרשת רופין': 'Midreshet Rupin',
  'מגדל': 'Migdal',
  'מגדל העמק': 'Migdal HaEmek',
  'מגדל עוז': 'Migdal Oz',
  'מגדלים': 'Migdalim',
  'מכמנים': 'Mikhmanim',
  'מכמורת': 'Mikhmoret',
  'מקווה ישראל': 'Mikveh Yisrael',
  'משגב עם': 'Misgav Am',
  'משגב דב': 'Misgav Dov',
  'משמר איילון': 'Mishmar Ayalon',
  'משמר דוד': 'Mishmar David',
  'משמר העמק': 'Mishmar HaEmek',
  'משמר הנגב': 'Mishmar HaNegev',
  'משמר השרון': 'Mishmar HaSharon',
  'משמר הירדן': 'Mishmar HaYarden',
  'משמרות': 'Mishmarot',
  'משמרת': 'Mishmeret',
  'מצפה אילן': 'Mitzpe Ilan',
  'מבטחים': 'Mivtachim',
  'מצפה': 'Mitzpe',
  'מצפה אביב': 'Mitzpe Aviv',
  'מצפה נטופה': 'Mitzpe Netofa',
  'מצפה רמון': 'Mitzpe Ramon',
  'מצפה שלם': 'Mitzpe Shalem',
  'מצפה יריחו': 'Mitzpe Yeriho',
  'מזרע': 'Mizra',
  'מולדת': 'Moledet',
  'מורן': 'Moran',
  'מורשת': 'Moreshet',
  'מוצא עילית': 'Motza Illit',
  'מגאר': 'Mughar',
  'מוקייבלה': 'Muqeible',
  'נעלה': 'Naale',
  'חמדת': 'Neta',
  'נחל עוז': 'Nahal Oz',
  'שיטים': 'Nahlieli',
  'נחלה': 'Nahliel',
  'נהלל': 'Nahalat Yehuda',
  'נחליאל': 'Nahariya',
  'נחם': 'Nahshon',
  'נהריה': 'Nahshonim',
  'נחף': 'Nahf',
  'נחשולים': 'Nahsholim',
  'נחשון': 'Nahshon',
  'נחשונים': 'Nahshonim',
  'נצאצרה (שבט)': 'Nazzara (Shevet)',
  'נטף': 'Netaf',
  'נטור': 'Netiv HaLamed-He',
  'נווה': 'Neve',
  'נצרת': 'Nazareth',
  'נעורים': 'Neurim',
  'נגבה': 'Negba',
  'נגוהות': 'Negohot',
  'נחלים': 'Nehalim',
  'נהורה': 'Nehora',
  'נחושה': 'Nehusha',
  'ניין': 'Nein',
  'נס עמים': 'Nes Ammim',
  'נס הרים': 'Nes Harim',
  'נס ציונה': 'Nes Tziona',
  'נשר': 'Nesher',
  'נטע': 'Netiv',
  'נטעים': 'Netiv HaShayara',
  'נתניה': 'Netanya',
  'נתיב העשרה': 'Netiv HaAsara',
  'נתיב הגדוד': 'Netiv HaGedud',
  'נתיב הלה': 'Netiv HaLamed-He',
  'נתיב השיירה': 'Netiv HaShayara',
  'נתיבות': 'Netivot',
  'נבטים': 'Nevatim',
  'נוה צוף': 'Neve Tzuf',
  'נווה אטיב': 'Neve Ativ',
  'נווה אבות': 'Neve Avot',
  'נווה דניאל': 'Neve Daniel',
  'נווה איתן': 'Neve Eitan',
  'נווה חריף': 'Neve Harif',
  'נווה אילן': 'Neve Ilan',
  'נווה מיכאל': 'Neve Michael',
  'נווה מבטח': 'Neve Mivtach',
  'נווה שלום': 'Neve Shalom',
  'נווה אור': 'Neot Mordekhai',
  'נווה ים': 'Neve Yam',
  'נווה ימין': 'Neve Yamin',
  'נווה ירק': 'Neve Yarak',
  'נווה זיו': 'Neve Ziv',
  'נווה זוהר': 'Neve Zohar',
  'נצר חזני': 'Netzer Hazani',
  'נצר סרני': 'Netzer Sereni',
  'נילי': 'Nili',
  'נמרוד': 'Nimrod',
  'ניר עם': 'Nir Am',
  'ניר עקיבא': 'Nir Aqiva',
  'ניר בנים': 'Nir Banim',
  'ניר דוד (תל עמל)': 'Nir David (Tel Amal)',
  'ניר אליהו': 'Nir Eliyahu',
  'ניר עציון': 'Nir Etzion',
  'ניר גלים': 'Nir Galim',
  'ניר חן': 'Nir Hen',
  'ניר משה': 'Nir Moshe',
  'ניר עוז': 'Nir Oz',
  'ניר יפה': 'Nir Yafe',
  'ניר ישראל': 'Nir Yisrael',
  'ניר יצחק': 'Nir Yitzhak',
  'ניר צבי': 'Nir Zvi',
  'נירים': 'Nirim',
  'נירית': 'Nirit',
  'ניצן': 'Nitzan',
  'ניצן ב': 'Nitzan Bet',
  'ניצנה (קהילת חינוך)': 'Nitzana (Kehilat Hinukh)',
  'ניצני עוז': 'Nitzanei Oz',
  'ניצני סיני': 'Nitzanei Sinai',
  'ניצנים': 'Nitzanim',
  'נועם': 'Noam',
  'נוף איילון': 'Nof Ayalon',
  'נוף הגליל': 'Nof HaGalil',
  'נופך': 'Nofekh',
  'נופים': 'Nofim',
  'נופית': 'Nofit',
  'נוגה': 'Noga',
  'נוקדים': 'Nokdim',
  'נורדיה': 'Nordia',
  'נוב': 'Nov',
  'נורית': 'Nurit',
  'אודם': 'Odem',
  'אופקים': 'Ofakim',
  'עופר': 'Ofer',
  'עופרה': 'Ofra',
  'אוהד': 'Ohad',
  'עולש': 'Olesh',
  'אומן': 'Oman',
  'עומר': 'Omer',
  'אומץ': 'Ometz',
  'אור עקיבא': 'Or Akiva',
  'אור הגנוז': 'Or HaGanuz',
  'אור הנר': 'Or HaNer',
  'אור יהודה': 'Or Yehuda',
  'אורה': 'Ora',
  'אורנים': 'Oranim',
  'אורנית': 'Oranit',
  'אורות': 'Orot',
  'אורטל': 'Ortall',
  'עתניאל': 'Otniel',
  'עוצם': 'Otzem',
  'פעמי תשז': 'Paamei Tashaz',
  'פלמחים': 'Palmachim',
  'פארן': 'Paran',
  'פרדס חנה-כרכור': 'Pardes Hanna-Karkur',
  'פרדסיה': 'Pardesiya',
  'פרוד': 'Parod',
  'פתיש': 'Patish',
  'פדיה': 'Pedaya',
  'פדואל': 'Peduel',
  'פדויים': 'Peduyim',
  'פלך': 'Pelekh',
  'פני חבר': 'Pene Hever',
  'פקיעין חדשה': 'Pekiin Hadasha',
  'פרזון': 'Perazon',
  'פרי גן': 'Perei Gan',
  'פסגות': 'Pesagot',
  'פתח תקווה': 'Petah Tikva',
  'פתחיה': 'Petahia',
  'פצאל': 'Petzal',
  'פורת': 'Porat',
  'פוריה עילית': 'Poriyya Illit',
  'פוריה - כפר עבודה': 'Poriyya - Kfar Avoda',
};
